import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconMoreActionsCircle: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill || '#D0D0D1';
  return (
    <Icon {...props}>
      <path
        opacity="0.7"
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill={fill}
      />
      <path
        d="M9.83984 17.7946C9.83984 18.947 10.8116 19.9187 11.964 19.9187C13.1523 19.9187 14.0882 18.947 14.0882 17.7946C14.0882 16.6063 13.1165 15.6704 11.964 15.6704C10.8116 15.6704 9.83984 16.6069 9.83984 17.7946Z"
        fill="white"
      />
      <path
        d="M9.83984 6.20182C9.83984 7.39011 10.8116 8.326 11.964 8.326C13.1523 8.326 14.0882 7.35429 14.0882 6.20182C14.0882 5.05011 13.1523 4.07764 11.964 4.07764C10.8116 4.07764 9.83984 5.04936 9.83984 6.20182Z"
        fill="white"
      />
      <path
        d="M9.83984 11.8908C9.83984 13.0791 10.8116 14.0149 11.964 14.0149C13.1523 14.0149 14.0882 13.0432 14.0882 11.8908C14.0882 10.7025 13.1165 9.7666 11.964 9.7666C10.8116 9.7673 9.83984 10.7032 9.83984 11.8908Z"
        fill="white"
      />
    </Icon>
  );
};

export default IconMoreActionsCircle;
